import {clsx} from 'clsx'

import styles from './Universe26BannerVisual.module.css'

// Keep the supplied artwork's paint order; delays follow its left-to-right wave instead.
const desktopShapes = [
  {d: 'M208.23 21H247.407V42H208.23V21Z', fill: '#583AF7', delay: 650},
  {d: 'M78.047 28H104.165V42H78.047V28Z', fill: '#583AF7', delay: 200},
  {d: 'M156.098 14H182.216V28H156.098V14Z', fill: '#180E27', delay: 550},
  {d: 'M247.406 0H286.583V21H247.406V0Z', fill: '#0FBF3E', delay: 700},
  {d: 'M104.063 14H130.181V28H104.063V14Z', fill: '#0FBF3E', delay: 350},
  {d: 'M156.098 28H182.216V42H156.098V28Z', fill: '#08872B', delay: 500},
  {d: 'M0.000144958 28H26.1182V42H0.000144958V28Z', fill: '#08872B', delay: 0},
  {d: 'M182.113 0H208.231V14H182.113V0Z', fill: '#AE85FF', delay: 600},
  {d: 'M130.082 28H156.2V42H130.082V28Z', fill: '#AE85FF', delay: 400},
  {d: 'M78.047 0H104.165V14H78.047V0Z', fill: '#AE85FF', delay: 250},
  {d: 'M26.0158 28H52.1338V42H26.0158V28Z', fill: '#AE85FF', delay: 50},
  {d: 'M130.082 0H156.2V14H130.082V0Z', fill: '#C05200', delay: 450},
  {d: 'M104.063 28H130.181V42H104.063V28Z', fill: '#BBA00A', delay: 300},
  {d: 'M52.0314 28H78.1494V42H52.0314V28Z', fill: '#BBA00A', delay: 100},
  {d: 'M52.0314 14H78.1494V28H52.0314V14Z', fill: '#F73678', delay: 150},
]

const mobileShapes = [
  {d: 'M78.049 28H104.167V42H78.049V28Z', fill: '#583AF7', delay: 200},
  {d: 'M104.065 14H130.183V28H104.065V14Z', fill: '#0FBF3E', delay: 300},
  {d: 'M0.00209808 28H26.1201V42H0.00209808V28Z', fill: '#08872B', delay: 0},
  {d: 'M78.049 0H104.167V14H78.049V0Z', fill: '#AE85FF', delay: 250},
  {d: 'M26.0177 28H52.1357V42H26.0177V28Z', fill: '#AE85FF', delay: 50},
  {d: 'M52.0335 28H78.1515V42H52.0335V28Z', fill: '#BBA00A', delay: 100},
  {d: 'M52.0335 14H78.1515V28H52.0335V14Z', fill: '#F73678', delay: 150},
]

const artworks = [
  {width: 197, shapes: mobileShapes, className: styles.mobileArtwork},
  {width: 380, shapes: desktopShapes, className: styles.desktopArtwork},
]

export function Universe26BannerVisual() {
  return (
    <div className={styles.visualContainer}>
      {artworks.map(({width, shapes, className}) => (
        <svg
          key={width}
          className={clsx(styles.visualImage, className)}
          width={width}
          height="42"
          viewBox={`0 0 ${width} 42`}
          preserveAspectRatio="xMaxYMid slice"
          fill="none"
          aria-hidden="true"
          focusable="false"
        >
          {shapes.map(({d, fill, delay}) => (
            <path key={d} d={d} fill={fill} className={styles.visualShape} style={{animationDelay: `${delay}ms`}} />
          ))}
        </svg>
      ))}
    </div>
  )
}
